import React, { useState, useEffect, useRef } from 'react';
import { CheckCircle, X } from 'react-feather'; 

// --- Local Image Imports for the Background Texture (FIXED) ---
import InteriorImage1 from '../../../assets/Images/Interior10.jpg';
// Original: Interior11.jpg | Assuming it's valid, as it's used as a replacement elsewhere.
import InteriorImage10 from '../../../assets/Images/Interior11.jpg';
// Original: Interior12.jpg | FIXED to Interior11.jpg (using 11 as a valid replacement) - Note: I will use Interior11 for the variable name that was InteriorImage20
import InteriorImage20 from '../../../assets/Images/Interior11.jpg'; // FIXED: was Interior12.jpg 
// Original: Interior13.jpg | FIXED to Interior15.jpg
import InteriorImage35 from '../../../assets/Images/Interior15.jpg'; // FIXED: was Interior13.jpg
// Original: Interior14.jpg | FIXED to Interior16.jpg
import InteriorImage6 from '../../../assets/Images/Interior16.jpg'; // FIXED: was Interior14.jpg
// Original: Interior15.jpg | Assuming it's valid, keeping it as a base.
import InteriorImage7 from '../../../assets/Images/Interior15.jpg'; 
// Original: Interior16.jpg | Assuming it's valid, keeping it as a base.
import InteriorImage8 from '../../../assets/Images/Interior16.jpg'; 
// Original: Interior17.jpg | FIXED to Interior19.jpg
import InteriorImage9 from '../../../assets/Images/Interior19.jpg'; // FIXED: was Interior17.jpg


// --- AnimateOnScroll Component (Unchanged) ---
const AnimateOnScroll = ({ children, direction = 'up', delay = 0, className = '' }) => {
    const [isVisible, setIsVisible] = useState(false);
    const ref = useRef(null);
    const directionClasses = {
        up: 'translate-y-20', down: '-translate-y-20',
        left: '-translate-x-20', right: 'translate-x-20',
    };
    const initialClasses = `opacity-0 ${directionClasses[direction]}`;
    const finalClasses = 'opacity-100 translate-y-0 translate-x-0';
    useEffect(() => {
        const observer = new IntersectionObserver(([entry]) => {
            setIsVisible(entry.isIntersecting);
        }, { threshold: 0.1 });
        const currentRef = ref.current;
        if (currentRef) observer.observe(currentRef);
        return () => { if (currentRef) observer.unobserve(currentRef) };
    }, []);
    return (
        <div ref={ref} className={`${className} transition-all duration-1000 ease-out ${isVisible ? finalClasses : initialClasses}`} style={{ transitionDelay: `${delay}ms` }} >
            {children}
        </div>
    );
};


const Contact = () => {
    // --- State for Form Data (Unchanged) ---
    const [formData, setFormData] = useState({ name: '', email: '', projectType: '', message: '' });
    const [isSubmitting, setIsSubmitting] = useState(false);
    const [isSuccessModalOpen, setIsSuccessModalOpen] = useState(false); 

    // --- Red/Black/White Theme Styles (Unchanged) ---
    const inputStyle = "contact-input w-full p-4 bg-black/70 border-2 border-white/20 rounded-lg text-white placeholder-gray-400 focus:ring-2 focus:ring-red-600 focus:border-red-600 transition duration-200";
    const buttonStyle = "w-full text-lg font-bold bg-red-600 text-white py-4 px-8 rounded-lg transition-all duration-300 hover:bg-red-700 hover:shadow-2xl hover:shadow-red-500/30 transform hover:-translate-y-1 disabled:bg-gray-700 disabled:shadow-none disabled:translate-y-0";
    
    // --- UPDATED: Target WhatsApp Number from image (9710366466 is first one, assuming this is the primary for WhatsApp) ---
    // Note: The number 9962310466 is also available, using the first one for the main line.
    const PRIMARY_PHONE_NUMBER = '9710366466';
    const SECONDARY_PHONE_NUMBER = '9962310466';
    const WHATSAPP_NUMBER = `91${SECONDARY_PHONE_NUMBER}`; // International format for India: 91 + 10-digit number.

    const handleChange = (e) => {
        const { id, value } = e.target;
        setFormData(prevState => ({ ...prevState, [id]: value }));
    };

    const handleSubmit = (e) => {
        e.preventDefault();
        
        setIsSubmitting(true);

        // --- 1. Construct the Professional WhatsApp Message (Unchanged) ---
        const messageText = `Hello! I am ${formData.name}, and I would like to discuss a new project. 
        
Project Type: ${formData.projectType || 'Not specified'}
Email: ${formData.email}

Details: 
${formData.message}

Please contact me at your earliest convenience. Thank you.`;

        // --- 2. Encode the message for the URL (Unchanged) ---
        const encodedMessage = encodeURIComponent(messageText.trim());

        // --- 3. Construct the WhatsApp URL (Unchanged) ---
        const whatsappUrl = `https://wa.me/${WHATSAPP_NUMBER}?text=${encodedMessage}`;

        // --- 4. Open WhatsApp and trigger success modal (Unchanged) ---
        window.open(whatsappUrl, '_blank');
        
        setIsSuccessModalOpen(true);

        // Reset state after a short delay (Unchanged)
        setTimeout(() => {
            setIsSubmitting(false);
        }, 1000);
    };
    
    // Effect to control body scroll when modal is open (Unchanged)
    useEffect(() => {
        if (isSuccessModalOpen) {
            document.body.style.overflow = 'hidden';
        } else {
            document.body.style.overflow = 'unset';
        }
        return () => { document.body.style.overflow = 'unset'; };
    }, [isSuccessModalOpen]);

    // --- Helper Component for Framed Images (Unchanged) ---
    const FramedImage = ({ src, alt, positionClass, rotationClass, sizeClass = 'w-32 h-48 lg:w-48 lg:h-64' }) => (
        <div 
            className={`absolute z-0 overflow-hidden border-2 border-white/50 opacity-20 transition-all duration-500 ease-out ${sizeClass} ${positionClass} ${rotationClass}`}
        >
            <img 
                src={src} 
                alt={alt} 
                className="w-full h-full object-cover saturate-50 contrast-125" 
            />
        </div>
    );

    // --- Studio address (Neelankarai) ---
    const STUDIO_ADDRESS = '#4/591 Vaithiyalingam salai, Neelankarai, Chennai - 115';
    // Google Maps embed for the Neelankarai studio (query-based embed, no API key required).
    const GOOGLE_MAPS_EMBED_URL = 'https://maps.google.com/maps?q=Vaithiyalingam%20Salai%2C%20Neelankarai%2C%20Chennai%20600115&z=15&output=embed'; 


    return (
        <>
            {/* Custom style for the map border (Unchanged) */}
            <style jsx>{`
                .map-container {
                    border: 3px solid #ff0000; /* Red border */
                    border-radius: 0.5rem; /* rounded-lg */
                    overflow: hidden; /* Ensures map adheres to border radius */
                    box-shadow: 0 0 15px rgba(255, 0, 0, 0.5); /* Red shadow for highlight */
                }
            `}</style>

            <section id="contact" className="py-24 bg-black relative overflow-hidden min-h-screen flex items-center">
                
                {/* --- Background Images (Uses FIXED Imports) --- */}
                <div className="absolute inset-0 w-full h-full z-0">
                    {/* Dark Background Overlay - Reduced to opacity-85 for slightly brighter images */}
                    <div className="absolute inset-0 bg-black opacity-85"></div> 

                    {/* Framed Images (Uses FIXED Imports) */}
                    <FramedImage src={InteriorImage1} alt="Design photo 1" positionClass="top-[5%] left-[5%]" rotationClass="-rotate-6" sizeClass="w-32 h-44 lg:w-40 lg:h-56" />
                    <FramedImage src={InteriorImage6} alt="Design photo 6" positionClass="top-[10%] left-[15%] right-[35%]" rotationClass="rotate-12" sizeClass="w-28 h-40 lg:w-40 lg:h-56" />
                    <FramedImage src={InteriorImage7} alt="Design photo 7" positionClass="top-[35%] left-[2%]" rotationClass="-rotate-8" sizeClass="w-36 h-52 lg:w-52 lg:h-72" />
                    <FramedImage src={InteriorImage20} alt="Design photo 3" positionClass="bottom-[5%] left-[2%]" rotationClass="rotate-6" sizeClass="w-32 h-48 lg:w-48 lg:h-64" />
                    <FramedImage src={InteriorImage10} alt="Design photo 2" positionClass="top-[10%] right-[10%]" rotationClass="rotate-12" sizeClass="w-32 h-48 lg:w-48 lg:h-64" />
                    <FramedImage src={InteriorImage8} alt="Design photo 8" positionClass="top-[30%] right-[5%]" rotationClass="-rotate-6" sizeClass="w-28 h-40 lg:w-40 lg:h-56" />
                    <FramedImage src={InteriorImage9} alt="Design photo 9" positionClass="top-[55%] right-[6%]" rotationClass="rotate-9" sizeClass="w-32 h-44 lg:w-44 lg:h-60" />
                    <FramedImage src={InteriorImage35} alt="Design photo 4" positionClass="bottom-[1%] right-[2%]" rotationClass="-rotate-12" sizeClass="w-36 h-52 lg:w-52 lg:h-72" />
                </div>
                {/* --- END SCATTERED IMAGES --- */}


                <div className="dark-content container mx-auto px-6 text-white relative z-10">
                    <AnimateOnScroll direction="down">
                        <div className="text-center mb-16">
                            <h2 className="text-5xl md:text-6xl font-extrabold text-white headline-font">Ready for a Transformation?</h2>
                            <p className="text-xl mt-4 max-w-3xl mx-auto text-white/80">
                                Let's discuss your vision. Fill out the form below or reach out directly to start crafting your signature space.
                            </p>
                        </div>
                    </AnimateOnScroll>
                    
                    <AnimateOnScroll direction="up" delay={200}>
                        {/* Form container size remains max-w-6xl with reduced vertical padding */}
                        <div className="max-w-6xl mx-auto bg-white/5 backdrop-blur-md border border-red-600/50 rounded-3xl shadow-red-900/40 shadow-2xl p-6 md:p-12">
                            <div className="grid md:grid-cols-2 gap-12">
                                {/* Left Side: Contact Info & Map */}
                                <div className="space-y-8 text-lg">
                                    <h3 className="text-3xl font-bold text-red-600 mb-6">Contact Details</h3>
                                    
                                    {/* UPDATED: Address */}
                                    <div>
                                        <h4 className="text-xl font-bold text-white mb-2">Design Studio (HQ)</h4>
                                        <p className="text-white/70">
                                            {STUDIO_ADDRESS.split(',').map((line, index) => (
                                                <React.Fragment key={index}>
                                                    {line.trim()}
                                                    {index < STUDIO_ADDRESS.split(',').length - 1 && <br />}
                                                </React.Fragment>
                                            ))}
                                        </p>
                                    </div>

                                    {/* UPDATED: Email */}
                                    <div>
                                        <h4 className="text-xl font-bold text-white mb-2">Email Us</h4>
                                        <a href="mailto:interiorsdred@gmail.com" className="block text-red-600 hover:text-red-400 font-semibold transition-colors">interiorsdred@gmail.com</a>
                                    </div>
                                    
                                    {/* UPDATED: Project Hotline */}
                                    <div className="mb-8">
                                        <h4 className="text-xl font-bold text-white mb-2">Project Hotline</h4>
                                        <a href={`tel:+91${PRIMARY_PHONE_NUMBER}`} className="block text-white/70 hover:text-white transition-colors">
                                            +(91) {PRIMARY_PHONE_NUMBER.substring(0, 5)} {PRIMARY_PHONE_NUMBER.substring(5)}
                                        </a>
                                        <a href={`tel:+91${SECONDARY_PHONE_NUMBER}`} className="block text-white/70 hover:text-white transition-colors">
                                            +(91) {SECONDARY_PHONE_NUMBER.substring(0, 5)} {SECONDARY_PHONE_NUMBER.substring(5)}
                                        </a>
                                        <a href={`https://wa.me/${WHATSAPP_NUMBER}`} target="_blank" rel="noopener noreferrer" className="block text-red-600 font-semibold hover:text-red-400 transition-colors mt-2">
                                            Click to WhatsApp
                                        </a>
                                    </div>
                                    
                                    {/* UPDATED: Embedded Map Section */}
                                    <div className="space-y-4">
                                        <h4 className="text-xl font-bold text-white">Find Our Studio</h4>
                                        <div className="map-container w-full h-48">
                                            {/* Google Maps Embed for Neelankarai studio */}
                                            <iframe 
                                                src={GOOGLE_MAPS_EMBED_URL} 
                                                width="100%" 
                                                height="100%" 
                                                style={{ border: 0 }} 
                                                allowFullScreen="" 
                                                loading="lazy" 
                                                referrerPolicy="no-referrer-when-downgrade"
                                                title="Office Location Map - Neelankarai"
                                            ></iframe>
                                        </div>
                                    </div>
                                </div>
                                
                                {/* Right Side: Form (Unchanged) */}
                                <form onSubmit={handleSubmit}>
                                    <div className="mb-6">
                                        <label htmlFor="name" className="block mb-2 font-semibold text-white">Your Name</label>
                                        <input type="text" id="name" className={inputStyle} value={formData.name} onChange={handleChange} required />
                                    </div>
                                    <div className="mb-6">
                                        <label htmlFor="email" className="block mb-2 font-semibold text-white">Your Email</label>
                                        <input type="email" id="email" className={inputStyle} value={formData.email} onChange={handleChange} required />
                                    </div>
                                    <div className="mb-6">
                                        <label htmlFor="projectType" className="block mb-2 font-semibold text-white">Project Type</label>
                                        <select id="projectType" className={inputStyle} value={formData.projectType} onChange={handleChange} required>
                                            <option value="" disabled>Select a project type</option>
                                            <option value="Residential - New Build">Residential - New Build</option>
                                            <option value="Residential - Renovation">Residential - Renovation</option>
                                            <option value="Commercial - Office">Commercial - Office</option>
                                            <option value="Commercial - Retail/Restaurant">Commercial - Retail/Restaurant</option>
                                            <option value="Consultation Only">Consultation Only</option>
                                        </select>
                                    </div>
                                    <div className="mb-8">
                                        <label htmlFor="message" className="block mb-2 font-semibold text-white">Tell us about your project goals</label>
                                        <textarea id="message" rows="5" className={inputStyle} value={formData.message} onChange={handleChange} required></textarea>
                                    </div>
                                    <button 
                                        type="submit" 
                                        disabled={isSubmitting}
                                        className={buttonStyle}
                                    >
                                        {isSubmitting ? 'Opening WhatsApp...' : 'Send Inquiry via WhatsApp'}
                                    </button>
                                </form>
                            </div>
                        </div>
                    </AnimateOnScroll>
                </div>
            </section>

            {/* --- Confirmation Modal (Unchanged) --- */}
            {isSuccessModalOpen && (
                <div className="fixed inset-0 bg-black bg-opacity-95 flex items-center justify-center z-[100] p-4">
                    <div className="bg-white rounded-2xl shadow-2xl p-8 md:p-12 max-w-md w-full text-center relative border-4 border-red-600 transform scale-105 transition-transform duration-300">
                        <button onClick={() => setIsSuccessModalOpen(false)} className="absolute top-4 right-4 text-gray-500 hover:text-red-600 transition-colors"> <X size={24} /> </button>
                        <CheckCircle className="w-20 h-20 text-red-600 mx-auto mb-6" />
                        <h3 className="text-3xl font-bold text-gray-800 mb-4">Chat Initiated!</h3>
                        <p className="text-gray-700 mb-8">
                            Your device's WhatsApp should now be open with the pre-filled message. Please hit Send to deliver your inquiry directly to our project hotline.
                        </p>
                        <button
                            onClick={() => setIsSuccessModalOpen(false)}
                            className="text-lg font-bold px-10 py-3 bg-black text-white rounded-lg transition-colors duration-300 hover:bg-gray-800"
                        >
                            Understood
                        </button>
                    </div>
                </div>
            )}
        </>
    );
};

export default Contact;
